import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { MainService } from '../../services/main-service.service';
import { ProposalService } from 'src/app/services/proposal/proposal.service';
import { BsModalService, BsModalRef, ModalDirective} from 'ngx-bootstrap/modal';
import { CallbackComponent } from '../../pages/callback/callback.component';
import { WriteToUsComponent } from 'src/app/pages/write-to-us/write-to-us.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  settingsData: any;
  modalRef: BsModalRef;
  @ViewChild('writeToUsModal') writeToUsModal: TemplateRef<any>;
  @ViewChild('callbackModal') callbackModal: TemplateRef<any>;
  @ViewChild('envModal') envModal: ModalDirective;
  environment: any = localStorage.getItem('environment') || '';
  public env = environment;
  planInfo: any = {
    patient_first_name: '',
    patient_last_name: '',
    patient_address: '',
    patient_email: '',
    patient_mobile: '',
    zip: '',
    message: ''
  };
  bsModalRef: BsModalRef;
  hideEnv = false;
  constructor(
    public mainService: MainService,
    public proposal: ProposalService,
    private modalService: BsModalService
  ) { }

  ngOnInit() {
    this.proposal.getPaymentData().subscribe((data: any) => {
      this.planInfo = data;
    });
    this.proposal.getData().subscribe((data: any) => {
      if (data.split_request_data) {
        this.planInfo = data.split_request_data[0];
      } else if (data && data.result && data.result.patient_email) {
        this.planInfo = data.result;
      }
    });
    this.proposal.getBusinessData().subscribe((data: any) => {
      this.planInfo = data;
    });
    // tslint:disable-next-line:triple-equals
    if (environment.production == true) {
      this.hideEnv = true;
    }
  }

  openWriteToUsModal() {
    const initialState = { data: this.planInfo };
    this.bsModalRef = this.modalService.show(WriteToUsComponent, { initialState });
    this.bsModalRef.setClass('modal-445');
  }

  openCallbackModal() {
    const initialState = { data: this.planInfo };
    this.bsModalRef = this.modalService.show(CallbackComponent, { initialState });
    this.bsModalRef.setClass('modal-445');
  }

  changeEnvironment() {
    localStorage.setItem('environment', this.environment);
    localStorage.setItem('request_url', environment.request_url);
    // switch (this.environment) {
    //   case 't1':
    //     // environment.request_url = 'https://testapi.credee.com/request/';
    //     // environment.open_api_url = 'https://testapi.credee.com/whitelabel/';
    //     localStorage.setItem('request_url', environment.request_url);
    //     break;
    //   case 't2':
    //     environment.request_url = 'https://testapi.credee.com/request/';
    //     localStorage.setItem('request_url', environment.request_url);
    //     break;
    //   case 't3':
    //     environment.request_url = 'https://testapi.credee.com/request/';
    //     localStorage.setItem('request_url', environment.request_url);
    //     break;
    //   case 't4':
    //     environment.request_url = 'https://testapi.credee.com/request/';
    //     localStorage.setItem('request_url', environment.request_url);
    //     break;
    //   case 't5':
    //     environment.request_url = 'https://testapi.credee.com/request/';
    //     environment.open_api_url = 'https://testapi.credee.com/whitelabel/';
    //     localStorage.setItem('request_url', environment.request_url);
    //     break;
    //   case 't6':
    //     environment.request_url = 'https://testapi.credee.com/request/';
    //     localStorage.setItem('request_url', environment.request_url);
    //     break;
    //   default:
    //     this.environment = 't1'
    //     environment.request_url = 'https://testapi.credee.com/request/';
    //     localStorage.setItem('request_url', environment.request_url);
    //     break;
    // }
  }

  cancelChangeEnv() {
    if (localStorage.getItem('environment')) {
      this.environment = localStorage.getItem('environment');
    }
  }

  openEnvModal(modal: any) {
    modal.show();
  }

}
